import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/auth/Login.vue";
import Forgotpassword from "../components/auth/Forgotpassword.vue";
import Resetpassword from "../components/auth/Resetpassword.vue";
import MainLayout from "../components/layout/Layout.vue";
import Dashboard from "../components/Dashboard.vue";
import Profile from "../components/Profile.vue";
import ChangePassword from "../components/ChangePassword.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Login",
    },
  },
  {
    path: "/forgot-password",
    name: "Forgotpassword",
    component: Forgotpassword,
    meta: {
      title: "Forgot password",
    },
  },
  {
    path: "/reset-password/:id/:token",
    name: "Resetpassword",
    component: Resetpassword,
    meta: {
      title: "Reset password",
    },
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: Profile,
        meta: {
          title: "Profile",
        },
      },
      {
        path: "change-password",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {
          title: "ChangePassword",
        },
      },
      {
        path: "/vendor/add",
        name: "AddVendor",
        meta: {
          title: "Add Vendor",
        },
        component: () => import("../components/vendor/Add"),
      },
      {
        path: "/vendor/edit/:id",
        name: "EditVendor",
        meta: {
          title: "Edit Vendor",
        },
        component: () => import("../components/vendor/Edit"),
      },
      {
        path: "/vendor/details/:vendor_id",
        name: "VendorDetails",
        meta: {
          title: "Vendor Details",
        },
        component: () => import("../components/vendor/Details"),
      },
      {
        path: "/vendor/add_object/:vendor_id",
        name: "AddVendorObject",
        meta: {
          title: "Add Vendor Object",
        },
        component: () => import("../components/vendor/object/Add"),
      },
      {
        path: "/vendor/edit_object/:id",
        name: "EditVendorObject",
        meta: {
          title: "Edit Object",
        },
        component: () => import("../components/vendor/object/Edit"),
      },
      {
        path: "/vendor/resource/:vendor_id",
        name: "ResourceList",
        meta: {
          title: "Resource List",
        },
        component: () => import("../components/vendor/resources/List"),
      },
      {
        path: "/vendor/add_resource/:vendor_id",
        name: "AddVendorResource",
        meta: {
          title: "Add Vendor Resource",
        },
        component: () => import("../components/vendor/resources/Add"),
      },
      {
        path: "/vendor",
        name: "VendorList",
        meta: {
          title: "Vendor List",
        },
        component: () => import("../components/vendor/List"),
      },
      {
        path: "/users",
        name: "UserList",
        meta: {
          title: "User List",
        },
        component: () => import("../components/attendee/List"),
      },
      {
        path: "/session",
        name: "SessionList",
        meta: {
          title: "Session List",
        },
        component: () => import("../components/session/List"),
      },
      {
        path: "/session/add",
        name: "AddSession",
        meta: {
          title: "Add Session",
        },
        component: () => import("../components/session/Add"),
      },
      {
        path: "/session/edit/:id",
        name: "EditSession",
        meta: {
          title: "Edit Session",
        },
        component: () => import("../components/session/Edit"),
      },
      {
        path: "/object",
        name: "ObjectList",
        meta: {
          title: "Object List",
        },
        component: () => import("../components/object/List"),
      },
      {
        path: "/object/add",
        name: "AddObject",
        meta: {
          title: "Add Object",
        },
        component: () => import("../components/object/Add"),
      },
      {
        path: "/object/edit/:id",
        name: "EditObject",
        meta: {
          title: "Edit Object",
        },
        component: () => import("../components/object/Edit"),
      },
      {
        path: "/user/edit/:id",
        name: "EditUser",
        meta: {
          title: "Edit User",
        },
        component: () => import("../components/attendee/Edit"),
      },
      {
        path: "/user/add",
        name: "AddUser",
        meta: {
          title: "Add User",
        },
        component: () => import("../components/attendee/Add"),
      },
      {
        path: "/category",
        name: "CategoryList",
        meta: {
          title: "Category List",
        },
        component: () => import("../components/category/List"),
      },
      {
        path: "/category/add",
        name: "AddCategory",
        meta: {
          title: "Add Category",
        },
        component: () => import("../components/category/Add"),
      },
      {
        path: "/category/edit/:id",
        name: "EditCategory",
        meta: {
          title: "Edit Category",
        },
        component: () => import("../components/category/Edit"),
      },
      {
        path: "/rooms",
        name: "Rooms",
        meta: {
          title: "Rooms",
        },
        component: () => import("../components/booth/Rooms"),
      },
      {
        path: "/room/:room_id",
        name: "RoomsDetails",
        meta: {
          title: "Rooms Details",
        },
        component: () => import("../components/booth/Assignment"),
      },
      {
        path: "/representative",
        name: "RepresentativeList",
        meta: {
          title: "Representative List",
        },
        component: () => import("../components/representative/List"),
      },
      {
        path: "/helpdesk",
        name: "Helpdesk",
        meta: {
          title: "Helpdesk",
        },
        component: () => import("../components/helpdesk/List"),
      },
      {
        path: "/notification",
        name: "Notification",
        meta: {
          title: "Notification",
        },
        component: () => import("../components/notification/List"),
      },
      {
        path: "/file",
        name: "FileUploader",
        meta: {
          title: "FileUploader",
        },
        component: () => import("../components/file-uploader/List"),
      },
      {
        path: "/file/add",
        name: "FileUploader",
        meta: {
          title: "FileUploader",
        },
        component: () => import("../components/file-uploader/Add"),
      },
      {
        path: "/testimonial",
        name: "Testimonials",
        meta: {
          title: "Testimonials",
        },
        component: () => import("../components/testimonial/List"),
      },
      {
        path: "/testimonial/add",
        name: "AddTestimonial",
        meta: {
          title: "Add Testimonial",
        },
        component: () => import("../components/testimonial/Add"),
      },
      {
        path: "/testimonial/edit/:id",
        name: "EditTestimonial",
        meta: {
          title: "Edit Testimonial",
        },
        component: () => import("../components/testimonial/Edit"),
      },
      // {
      //   path: "/team",
      //   name: "TeamList",
      //   meta: {
      //     title: "TeamList",
      //   },
      //   component: () => import("../components/team/List"),
      // },
      {
        path: "/team_member/add",
        name: "TeamMemberAdd",
        meta: {
          title: "TeamMemberAdd",
        },
        component: () => import("../components/team/Add"),
      },
      {
        path: "/team_member/edit/:id",
        name: "TeamMemberEdit",
        meta: {
          title: "TeamMemberEdit",
        },
        component: () => import("../components/team/Edit"),
      },
      {
        path: "/board",
        name: "BoardList",
        meta: {
          title: "BoardList",
        },
        component: () => import("../components/board/List"),
      },
      {
        path: "/board_member/add",
        name: "BoardMemberAdd",
        meta: {
          title: "BoardMemberAdd",
        },
        component: () => import("../components/board/Add"),
      },
      {
        path: "/board_member/edit/:id",
        name: "BoardMemberEdit",
        meta: {
          title: "BoardMemberEdit",
        },
        component: () => import("../components/board/Edit"),
      },
      {
        path: "/inquiry",
        name: "Inquiry",
        meta: {
          title: "Inquiry",
        },
        component: () => import("../components/inquiry/List"),
      },
      {
        path: "/vendor-inquiry",
        name: "Inquiry",
        meta: {
          title: "Inquiry",
        },
        component: () => import("../components/vendor_inquiry/List"),
      },
      {
        path: "/inquiry/:id",
        name: "InquiryDetails",
        meta: {
          title: "InquiryDetails",
        },
        component: () => import("../components/inquiry/Details"),
      },
      {
        path: "/pricing",
        name: "Pricing",
        meta: {
          title: "Pricing",
        },
        component: () => import("../components/pricing/List"),
      },
      {
        path: "/pricing/add",
        name: "PricingAdd",
        meta: {
          title: "Add Pricing",
        },
        component: () => import("../components/pricing/Add"),
      },
      {
        path: "/pricing/edit/:id",
        name: "PricingEdit",
        meta: {
          title: "Edit Pricing",
        },
        component: () => import("../components/pricing/Edit"),
      },
      // templates
      {
        path: "/templates",
        name: "EmailTemplates",
        meta: {
          title: "EmailTemplates",
        },
        component: () => import("../components/templates/List"),
      },
      {
        path: "/email-configuration",
        name: "EmailConfiguration",
        meta: {
          title: "EmailConfiguration",
        },
        component: () => import("../components/email-configuration/Edit"),
      },
      {
        path: "/templates/edit/:id",
        name: "EditTemplates",
        meta: {
          title: "EditTemplates",
        },
        component: () => import("../components/templates/Edit"),
      },
      {
        path: "/main-lobby",
        name: "Main Lobby",
        meta: {
          title: "Main Lobby",
        },
        component: () => import("../components/main-lobby/Add"),
      },
      {
        path: "/exhibit-hall",
        name: "Exhibit Hall",
        meta: {
          title: "Exhibit Hall",
        },
        component: () => import("../components/exibit-hall/Add"),
      },
      {
        path: "/contact-us",
        name: "ContactUs",
        meta: {
          title: "ContactUs",
        },
        component: () => import("../components/contact-us/Add"),
      },
      {
        path: "/events",
        name: "Events",
        meta: {
          title: "Events",
        },
        component: () => import("../components/events/List.vue"),
      },
      {
        path: "/events/add",
        name: "EventsAdd",
        meta: {
          title: "Add Event",
        },
        component: () => import("../components/events/Add.vue"),
      },
      {
        path: "/events/edit/:id",
        name: "EventsEdit",
        meta: {
          title: "Edit Event",
        },
        component: () => import("../components/events/Edit.vue"),
      },
      {
        path: '/whoweare',
        name: 'WhoWeAre',
        meta: {
          title: "Who we are"
        },
        component: () => import("../components/whoweare/List.vue")
      },
      {
        path: '/hallway-categories/list',
        name: 'HallwayCategories',
        meta: {
          title: "Hallway Categories"
        },
        component: () => import("../components/hall_categories/List.vue")
      }
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.VUE_APP_BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/forgot-password",
    "/reset-password/" + to.params.id + "/" + to.params.token,
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = JSON.parse(localStorage.getItem("vbc_admin"));
  document.title = to.meta.title
  if (authRequired && !loggedIn) {
    next("/login");
  } else if (!authRequired && loggedIn) {
    next("/dashboard");
  } else {
    next();
  }
});
export default router;
